var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAloneMarginTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#BFBFBF",
    t: 1641387445929,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 25218,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M723.2 545.28l-211.2-211.2-211.2 211.2-60.373333-60.373333L512 213.333333l271.573333 271.573334zM256 725.333333v85.333334h512v-85.333334z",
    "p-id": 25219
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAloneMarginTop);
export default __webpack_public_path__ + "static/media/alone-margin-top.3177ab567adc17ffac6ae3139b16b955.svg";
export { ForwardRef as ReactComponent };